import React from "react";

const HeroSection = () => (
  <section className="relative h-screen min-h-[640px] w-full overflow-hidden">
    <img
      src="/images/hero.jpg"
      alt="Luxury stone estate home represented by Roger Minner Homes"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 hero-overlay" />

    <div className="relative z-10 h-full flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-5xl text-center">
        <h1 className="brand-title text-white text-[3.2rem] leading-[0.95] sm:text-7xl md:text-8xl lg:text-[7.5rem] uppercase">
          Roger Minner
        </h1>
        <div className="flex items-center justify-center gap-5 my-2 md:my-3">
          <span className="hero-line w-24 md:w-52" />
          <span className="hero-line w-24 md:w-52" />
        </div>
        <h2 className="brand-title text-white text-[3.2rem] leading-[0.95] sm:text-7xl md:text-8xl lg:text-[7.5rem] uppercase">
          Homes
        </h2>
      </div>
    </div>

    <div className="absolute bottom-8 right-8 z-10 hidden sm:block">
      <div className="real-logo">
        <span className="real-word">real</span>
        <span className="real-sub">Broker, LLC</span>
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
      <div className="w-[1px] h-14 bg-white/60 animate-pulse" />
    </div>
  </section>
);

export default HeroSection;
